"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Link from "@/components/ui/Link";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import FourIconBar from "../ui/MessagePrint";
import PremiumBadge from "../ui/PremiumBadge";
import SocialIcons from "@/components/header/SocialIcons";
import Publishon from "@/components/ui/publishon";
import MessagePrint from "../ui/MessagePrint";
import { MessageIconLogo } from "../ui/message-icon-logo";
import ArticleShareButtons from "@/components/component_unique/ArticleShareButtons";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
type Props = {
  category?: string;
  sectionUrl?: string;
  title?: string;
  excerpt?: string;
  embedUrl?: string;
  thumbnailUrl?: string;
  imageCaption?: string;
  imageAttribution?: string;
  publishedAt?: string;
  updatedAt?: string;
  cards?: any[];
  showPublished?: boolean;
  slug?: string;
  articleUrl?: string;
};

// Helper function to add parameters to YouTube embed URL
const getCleanYouTubeUrl = (embedUrl: string, autoplay: boolean = false): string => {
  if (!embedUrl) return '';
  try {
    const url = new URL(embedUrl);
    url.searchParams.set('modestbranding', '1');
    url.searchParams.set('rel', '0');
    url.searchParams.set('showinfo', '0');
    url.searchParams.set('iv_load_policy', '3');
    url.searchParams.set('controls', '1');
    url.searchParams.set('fs', '1');
    if (autoplay) {
      url.searchParams.set('autoplay', '1');
    }
    return url.toString();
  } catch {
    return embedUrl;
  }
};
export default function BigNewsVideo(t0) {
  const $ = _c(47);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    embedUrl,
    thumbnailUrl,
    imageCaption,
    imageAttribution,
    publishedAt,
    updatedAt,
    cards,
    showPublished: t4,
    slug,
    articleUrl
  } = t0;
  const category = t1 === undefined ? "INDIA" : t1;
  const title = t2 === undefined ? "\"\u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BCB\u0BB3\u0BBE\u0BB1\u0BC7 \u0B95\u0BBE\u0BB0\u0BA3\u0BAE\u0BCD...\"- \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD\u0BB5\u0BC7 \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0BB0\u0BCD \u0BA4\u0B95\u0BB5\u0BB2\u0BCD..!" : t2;
  const excerpt = t3 === undefined ? "\u0BAE\u0BC7\u0BB1\u0BCD\u0B95\u0BC1\u0BB5\u0B99\u0BCD\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BB7\u0BBE\u0BB2\u0BBF\u0BAE\u0BB0\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8 \u0BA8\u0BCB\u0B95\u0BCD\u0B95\u0BBF \u0BB5\u0BA8\u0BCD\u0BA4 \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 " : t3;
  const showPublished = t4 === undefined ? true : t4;
  useState(false);
  let t5;
  if ($[0] !== cards?.[0] || $[1] !== embedUrl) {
    t5 = embedUrl || cards?.[0]?.["story-elements"]?.find(_temp)?.["embed-url"];
    $[0] = cards?.[0];
    $[1] = embedUrl;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const videoEmbedUrl = t5;
  const videoIdMatch = videoEmbedUrl?.match(/(?:youtube\.com\/.*v=|youtu\.be\/)([^"&?\/\s]{11})/);
  videoIdMatch ? `https://img.youtube.com/vi/${videoIdMatch[1]}/hqdefault.jpg` : thumbnailUrl;
  let t6;
  if ($[3] !== category || $[4] !== sectionUrl) {
    t6 = category !== "\u0BB5\u0BBF\u0BB3\u0BAE\u0BCD\u0BAA\u0BB0\u0BA4\u0BBE\u0BB0\u0BB0\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0B95\u0BB3\u0BCD" && (sectionUrl ? <Link href={sectionUrl} className="text-16-tamil-600 text-012061 tracking-wide uppercase hover:underline">{category}</Link> : <div className="text-16-tamil-600 text-012061 tracking-wide uppercase">{category}</div>);
    $[3] = category;
    $[4] = sectionUrl;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `video-${slug || ""}`;
  const t8 = articleUrl || (slug ? `/${slug}` : undefined);
  let t9;
  if ($[6] !== excerpt || $[7] !== slug || $[8] !== t7 || $[9] !== t8 || $[10] !== thumbnailUrl || $[11] !== title) {
    t9 = <div className="flex items-center gap-1 text-4D4D4D"><MessageIconLogo id={t7} variant="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={title} thumbnailUrl={thumbnailUrl} description={excerpt} articleUrl={t8} /></div>;
    $[6] = excerpt;
    $[7] = slug;
    $[8] = t7;
    $[9] = t8;
    $[10] = thumbnailUrl;
    $[11] = title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div className="flex justify-between items-center text-012061 text-16-english-600">{t6}{t9}</div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== title) {
    t11 = <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4"><h1 className="text-012061 text-32-tamil-700 md:text-16-tamil-700 leading-[1.5] tracking-wide flex-1">{title}</h1></div>;
    $[16] = title;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== excerpt) {
    t12 = <h2 className="text-020202 text-18-tamil-400 leading-[1.5]">{excerpt}</h2>;
    $[18] = excerpt;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12) {
    t13 = <div className="flex flex-col gap-4">{t10}{t11}{t12}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== title || $[25] !== videoEmbedUrl) {
    t14 = videoEmbedUrl && <div className="relative w-full aspect-video"><iframe src={getCleanYouTubeUrl(videoEmbedUrl, false)} title={title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} className="absolute top-0 left-0 w-full h-full rounded" /></div>;
    $[24] = title;
    $[25] = videoEmbedUrl;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== imageAttribution || $[28] !== imageCaption) {
    t15 = (imageCaption || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-14-tamil-400"><p>{imageCaption && <span className="text-black">{imageCaption}</span>}{imageCaption && imageAttribution && " - "}{imageAttribution && <span style={{
          color: "#00000099"
        }}>{imageAttribution}</span>}</p></div>;
    $[27] = imageAttribution;
    $[28] = imageCaption;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const t16 = publishedAt || "08 May 2023 , 10:30 AM";
  const t17 = updatedAt || "08 May 2023 , 10:30 AM";
  let t18;
  if ($[30] !== showPublished || $[31] !== t16 || $[32] !== t17) {
    t18 = <div className="w-full sm:w-auto text-11-tamil-300 text-1B1B1B line-clamp-1"><Publishon publishedOn={t16} updatedOn={t17} showPublished={showPublished} /></div>;
    $[30] = showPublished;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = slug || "";
  let t20;
  if ($[34] !== t19 || $[35] !== title) {
    t20 = <div className="w-full sm:w-auto"><ArticleShareButtons slug={t19} title={title} className="!p-0 !gap-1" /></div>;
    $[34] = t19;
    $[35] = title;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t18 || $[38] !== t20) {
    t21 = <div className="mt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">{t18}{t20}</div>;
    $[37] = t18;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t21) {
    t22 = <div className="w-full">{t14}{t15}{t21}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t13 || $[45] !== t22) {
    t23 = <article className="flex flex-col overflow-hidden p-4 gap-4">{t13}{t22}</article>;
    $[44] = t13;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
}
function _temp(element) {
  return element["embed-url"];
}